import { useEffect, useRef, useState } from 'react';
import { ArrowUpRight, X } from 'lucide-react';

function listing(value: string | undefined, host: string) {
  try {
    const url = new URL(value || '');
    return url.protocol === 'https:' && url.hostname === host ? url.href : null;
  } catch { return null; }
}

export function AppDownloads({ apple = import.meta.env.VITE_APP_STORE_URL, google = import.meta.env.VITE_GOOGLE_PLAY_URL }: { apple?: string; google?: string }) {
  const stores = [
    { name: 'App Store', href: listing(apple, 'apps.apple.com'), image:'/images/app-store-badge.svg' },
    { name: 'Google Play', href: listing(google, 'play.google.com'), image:'/images/google-play-logo.png' },
  ];
  return <div className="app-downloads">
    <strong>Fideliza para sua equipe.</strong>
    <p>Gerencie seu negócio pelo celular.</p>
    <div className="store-links">{stores.map(store => store.href
      ? <a key={store.name} href={store.href} aria-label={`Baixar na ${store.name}`}><img src={store.image} alt={store.name} width="140" height="42" loading="lazy" decoding="async"/><ArrowUpRight size={16} aria-hidden="true" /></a>
      : <button key={store.name} disabled aria-label={`${store.name} — indisponível no momento`}><img src={store.image} alt={store.name} width="140" height="42" loading="lazy" decoding="async"/></button>)}</div>
  </div>;
}

export function CookiePreferences() {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const trigger = useRef<HTMLButtonElement>(null);
  const panel = useRef<HTMLDivElement>(null);
  const closeButton = useRef<HTMLButtonElement>(null);
  function close() { setOpen(false); trigger.current?.focus(); }
  useEffect(() => {
    if (!open) return;
    closeButton.current?.focus();
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, [open]);
  function save() {
    try {
      localStorage.setItem('fideliza.landing.privacy.v1', JSON.stringify({ necessary: true, optional: false }));
      close();
    } catch { setError('Não foi possível salvar neste navegador. Nenhum rastreamento opcional foi ativado.'); }
  }
  return <>
    <button className="footer-preferences" ref={trigger} onClick={() => { setError(''); setOpen(true); }}>Preferências de cookies</button>
    {open && <div className="privacy-backdrop" onClick={event => { if (event.target === event.currentTarget) close(); }}>
      <div className="privacy-dialog" role="dialog" aria-modal="true" aria-labelledby="privacy-dialog-title" aria-describedby="privacy-dialog-description" ref={panel} onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const controls = panel.current?.querySelectorAll<HTMLButtonElement>('button:not(:disabled)');
          if (!controls?.length) return;
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }}>
        <button className="privacy-close" ref={closeButton} aria-label="Fechar preferências" onClick={close}><X size={22} /></button>
        <h2 id="privacy-dialog-title">Preferências de cookies</h2>
        <p id="privacy-dialog-description">Esta landing não utiliza cookies de publicidade ou análise. Sua preferência é salva apenas neste navegador.</p>
        <label className="privacy-category"><input type="checkbox" checked disabled /><span><strong>Necessários</strong><small>Armazenamento local para lembrar esta escolha. Sempre ativo.</small></span></label>
        <p>Cookies opcionais: não utilizados nesta página.</p>
        {error && <p role="alert">{error}</p>}
        <button className="button button--primary" onClick={save}>Salvar preferências</button>
      </div>
    </div>}
  </>;
}
